import { Tabs, Radio } from 'antd';
import React from 'react';
import './BetterTabs.css';
import AccordianTree from './AccordianTree';

const TabPane = Tabs.TabPane;

class BetterTabs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: 'top',
    };
  }

  handleModeChange = (e) => {
    const mode = e.target.value;
    this.setState({ mode });
  }

  render() {
    const { classes, type, designatedHandler, checkedKeys, switchOption, filterOptions  } = this.props;
    const { mode } = this.state;
    let arrTrees = [
        {disease: "Diabetes"},
        {disease: "Diabetes(VA)"}
    ];

    return (
      <div className='maxWidth'>
        <Tabs
          defaultActiveKey="0"
          tabPosition={mode}
        >
            {filterOptions.map((tab, i) => {
        return (
            <TabPane tab={tab["disease"]} key={i}>
                <AccordianTree type={type} designatedHandler={designatedHandler} checkedKeys={checkedKeys} switchOption={switchOption} filterOptions={tab["tree"]}></AccordianTree>
            </TabPane>
        );
    })}
        </Tabs>
        
      </div>
    );
    }
}
export default BetterTabs;



// WEBPACK FOOTER //
// ./src/NavBar/SelectDialog/BetterTabs.js